/** @flow */
import client, { clientMessages } from "@modules/client/translations";
import hierarchy, { hierarchyMessages } from "@modules/hierarchy/translations";
import employee, { employeeMessages } from "@modules/employee/translations";
import home from "@modules/home/translations";
import login from "@modules/account/translations";
import profile, { profileMessages } from "@modules/profile/translations";
import reporting, { reportingMessages } from "@modules/reporting/translations";
import components from "@components/translations";
import service, { serviceMessages } from "@modules/service/translations";
import data from "@modules/data/translations";
import help from "@modules/help/translations";
import changelog from "@components/change-log/translations";
import mobileApp from "@modules/mobile-app/translations";
import shared from "@modules/shared/translations";
import integrations, { integrationsMessages } from "@modules/integrations/translations";

export const translations = {
  en: {
    ...client.en,
    ...hierarchy.en,
    ...employee.en,
    ...home.en,
    ...login.en,
    ...profile.en,
    ...reporting.en,
    ...components.en,
    ...service.en,
    ...data.en,
    ...changelog.en,
    ...shared.en,
    ...help.en,
    ...mobileApp.en,
    ...integrations.en,
    // Common
    HOME: "Home",
    GO_HOME: "Go Home",
    CENTRAL: "Central",
    ADMINISTRATION: "Administration",
    ACTION: "Action",
    ACTIVE: "Active",
    NOT_ACTIVE: "Not Active",
    LOCKED: "Locked",
    LOCK: "Lock",
    UNLOCKED: "Unlocked",
    UNREGISTERED: "Unregistered",
    DESELECT: "Deselect",
    SELECT_ALL: "Select All",
    COPY_SELECTION: "Copy Selection",
    SELECT_COLUMN: "Select Column(s)",
    ROWS: "Row",
    SELECT_ROW: "Select Row(s)",
    BRAND_NAME: "GoodShapeCentral!",
    BRAND_HEADING: "Absence Management Solution",
    TRANSFER_ABSENCE: "Transfer Absence",
    GO_TO_PAGE: "Go to Page",
    GO: "Go",
    STAGE: "Stage",
    LOW_RES_BANNER_TEXT:
      "We have detected that you are using a device with a limited screen width. To get the best user experience consider adjusting your zoom to 80%.",
    CHANGE: "Change",
    CHANGE_CLIENT: "Change Client",
    CHANGE_EMPLOYEE: "Change Employee",
    INACTIVE: "Inactive",
    NON_SERVICE_USER: "Non Service User",
    MANAGEMENT: "Management",
    RECORDING: "Recording",
    REPORTING: "Reporting",
    STATUS: "Status",
    CREATED_BY: "Created By",
    END_DATE: "End Date",
    VALUE: "Value",
    FIRSTCARE_LTD_2019_ALL_RIGHTS_RESERVED: "GoodShape Ltd 2019. All Rights Reserved",
    PRIVACY: "Privacy",
    SUPPRESSION: "Suppression",
    HYPERLINKS: "Hyperlinks",
    CONTENT: "Content",
    EMAIL_CONTENT: "Email Content",
    EMAIL_DOMAINS: "Email Domains",
    ABOUT_US: "About Us",
    ABSENCE_MANAGEMENT_SOLUTIONS: "Absence Management Solutions",
    GO_BACK: "Go back",
    HEADER_MENU: "Header menu",
    HOME_LOGO: "Home logo",
    DIAGRAM: "Diagram",
    CARET: "Caret",
    LOW: "Low",
    MEDIUM: "Medium",
    HIGH: "High",
    DEI: "D.E.I",
    FEATURES: "Features",
    BENEFITS: "Benefits",
    UPGRADE_ACCOUNT: "Upgrade your account to access this service.",
    // Changelog Table
    DATE_CHANGED: "Date Changed",
    CHANGED_BY: "Changed By",
    CHANGED_AT: "Changed At",
    SUBMITTED_BY: "Submitted By",
    SUBMITTED_AT: "Submitted At",
    NUMBER_OF_CHANGES: "Number Of Changes",
    VALUE_CHANGED: "Value Changed",
    OLD_VALUE: "Old Value",
    NEW_VALUE: "New Value",
    // Form
    BACK: "Back",
    SUBMIT: "Submit",
    RESET: "Reset",
    EXPORT: "Export",
    ARCHIVE: "Archive",
    EXPAND: "Expand",
    VIEW: "View",
    EDIT: "Edit",
    DUPLICATE: "Duplicate",
    EDIT_DETAILS: "Edit Details",
    MANAGE: "Manage",
    SEARCH: "Search",
    SEARCH_DOTS: "Search...",
    REVERT: "Revert",
    CANCEL: "Cancel",
    REMOVE: "Remove",
    SAVE: "Save",
    SAVE_AS_NEW: "Save as New",
    AS: "As",
    APPLY_FILTERS: "Apply Filters",
    ALL: "All",
    RECENT: "Recent",
    SELECT: "Select",
    SEARCH_RESULTS: "Search Results",
    DISABLE: "Disable",
    ENABLE: "Enable",
    DISMISS: "Dismiss",
    ARE_YOU_SURE: "Are you sure?",
    ATTENTION: "Attention",
    CLOSE: "Close",
    SEARCH_AGAIN: "Search Again",
    "N/A": "N/A",
    NAME: "Name",
    FILE_NAME: "File Name",
    NEXT: "Next",
    PREV: "Prev",
    FAILED: "Failed",
    FAILURE: "Failure",
    SUCCESS: "Success",
    CONTINUE: "Continue",
    OPEN: "Open",
    OPERATION: "Operation",
    DATE_AND_TIME: "Date and Time",
    DAY: "Day",
    DATE: "Date",
    DATE_FROM: "Date From",
    DATE_TO: "Date To",
    DOWNLOAD: "Download",
    ENABLED: "Enabled",
    DISABLED: "Disabled",
    PERIOD: "Period",
    SUBMIT_CHANGES: "Submit Changes",
    DISCARD_DRAFT: "Discard Draft",
    JUMP_TO: "Jump to",
    DELETE_SELECTED: "Delete Selected",
    ADD_NEW: "Add New",
    RESULTS: "Results",
    // Select client bar
    SELECT_CLIENT_BAR_PLACEHOLDER: "Select Client / Type to Search",
    SURNAME: "Surname",
    LAST_NAME: "Last Name",
    TRAINING: "Training",
    INSIGHT_TRAINING_HUB: "Insight Training Hub",
    TRAINING_HUB: "Training Hub",
    CONTACT_US: "Contact Us",
    PLEASE_APPLY_QUESTION_OR: "Please apply question or",
    NEED_HELP: "Need help?",
    PRIVACY_FAIR_PROCESSING: "Privacy & Fair Processing",
    HOW_CAN_WE_HELP: "How can we help?",
    SEARCH_THE_LIST_OF_TOPICS_ON_THE_LEFT_TO_GET_STARTED:
      "Search the list of topics on the left to get started.",
    WATCH_VIDEO: "Watch Video",
    LATEST_NEWS: "Latest News",
    SHORTCUTS: "Shortcuts",
    ONE_MOMENT_PLEASE: "One moment please...",
    PRODUCTS_N_SERVICES: "Products & Services",
    LATEST_RELEASE_NOTES: "Latest Release Notes",
    NEW_RELEASE_NOTES_TITLE: "GoodShapeCentral has been updated!",
    NEW_RELEASE_NOTES_TEXT:
      "Welcome to Version {version} of the platform. We’ve made some changes since you last visited. To catch-up on what’s new or different, download the release notes below",
    GOODSHAPE_PRODUCTS: "Goodshape Products",
    REVIEW_YOUR_CURRENT_SET_UP: "Review your current set-up.",
    SERVICES_HUB: "Services Hub",
    CONNECT_YOUR_WELLBEING_SERVICES: "Connect your wellbeing services.",
    PARTNER_SPOTLIGHT_PLUMM: "Partner Spotlight: Plumm",
    MENTAL_HEALTH_THERAPY_SERVICES: "Mental Health Therapy Services",
    VIDEOS: "Videos",
    BASIC_TUTORIALS: "Basic Tutorials",
    TUTORIALS: "Tutorials",
    ADVANCED_TUTORIALS: "Advanced Tutorials",
    TUTORIAL_INTRODUCTION: "Introduction",
    TUTORIAL_RUNNING_REPORTS: "Running Reports",
    TUTORIAL_RTW_INTRVIEWS: "RTW Interviews",
    HOW_TO_SCHEDULE_REPORTS: "How to Schedule Reports",
    EMPLOYEE_RECORDS: "Employee Records",
    TUTORIAL_ABSENCE_RATES: "Absence Rates",
    TUTORIAL_ABSENCE_RATES_2: "Absence Rate Part 2",
    TUTORIAL_ABSENCE_RATES_1: "Absence Rate Part 1",
    TUTORIAL_RUNNING_PRESENTATIONS: "Running Presentations",
    EDITING_CHARTS: "Editing Charts",
    COMING_SOON: "Coming Soon",
    USER_GUIDE: "User Guide",
    ACCESS_TYPES: "Access Types",
    HOME_TITLE_WELCOME: "Hello, {name}",
    GOOD_SHAPE: "GoodShape!",
    WELCOME_TO_GOOD_SHAPE_CENTRAL: "Welcome to GoodShape!",
    HOME_WELCOME_TO_INSIGHT_FIRST_LOGIN_TEXT:
      "Thank you for registering your account on GoodShapeCentral. We have prepared a series of tutorials to guide you through the system. Would you like to view these now? If not, you can find them any time by visiting the Training page.",
    FIND_THEM_LATER: "No, Find Them Later",
    VIEW_NOW: "Yes, View Tutorials Now",
    ACCESS_TOOLS: " account which allows you to access the following tools...",
    GO_TO_GOOD_SHAPE_HEALTH: "Go to GoodShape Health",
    HEALTH_APP_MESSAGE: `The <b>Recording</b> and <b>Management</b> sections have been moved to <b>GoodShape Health</b>. Click on the button below to be redirected to GoodShape Health...`,
    YOU_HAVE_A: "You have a ",
    MONITORING_TITLE: "Monitoring",
    ABSENCE_MONITORING_HISTORY: "Level History",
    OTHER_ACTIVITIES: "Other Activities",
    FINAL_RTW_DATE: "Final RTW Date",
    DAYS_CHANGE: "Days Change",
    OPTIONS: "Options",
    NAVIGATE: "Navigate",
    EMPLOYEE_REFERRAL: "Employee Referral",
    MANAGER_REFERRAL: "Manager Referral",
    MANUAL_REFERRAL: "Manual Referral",
    NO_DATA_MESSAGE: "No data",
    NEW_SYSTEM_MESSAGE: "NEW !",
    LEARN_MORE_SIGN: "Learn More",
    NEXT_VIDEO: "Next Video",

    // Days of the Week
    MON: "Monday",
    TUE: "Tuesday",
    WED: "Wednesday",
    THU: "Thursday",
    FRI: "Friday",
    SAT: "Saturday",
    SUN: "Sunday",

    // Session
    SESSION_EXPIRES_IN_FORMATTED_TIME: "Session expires in {formattedTime}",
    PAGE_NOT_FOUND: "Page Not Found",
    PAGE_NOT_FOUND_DESCRIPTION: "The page you are trying to access doesn't exist.",
    NO_SHIFT_PATTERN_FOUND:
      "No shift pattern has been recorded for this absence, please select the 'Edit Pattern' button to update this record",
    REMEMBER_TO_ADD_A_SHIFT_PATTERN_TO_THE_ABSENCE:
      "Remember to add a shift pattern to the absence by selecting the magnifying glass on the following page",
    COLLAPSE: "Collapse",
    BACK_TO_TOP: "Back To Top",
    THERE_ARE_OUTSTANDING_TASKS: `There are {tasksCount} outstanding tasks.`,
    NO_OUTSTANDING_TASKS: `Good news! There are no outstanding tasks for this employee.`,
    RELEVANT_ABSENCE: `Relevant Absence`,
    ABSENCE_NOTE_TYPE: `Absence Note Type`,
    RELEVANT_ABSENCE_DROPDOWN_ITEM: `Absence ID: {id} (Start Date: {startDate})`,
    SELECT_EMPLOYEE_TO_TRANSFER_ABSENCE_TO: `1/2 Select Employee To Transfer Absence To`,
    SELECT_POSITION_TO_ASSIGN_SHIFT_PATTERN_TO: `2/2 Select Position to Assign Shift Pattern To`,
    TRANSFER_ABSENCE_CONFIRMATION_TEXT: `Are you sure you want to transfer Absence ID {absenceId} from {fromName} to {toName} ?`,
    NON_ABSENCE_SPECIFIC: "Non-Absence Specific",
    DELETE_NOTE: "Delete Note",
    CONFIRM_NOTE_DELETION: "Are you sure you want to delete this note ?",
    SEARCH_EMPLOYEE_SURNAME: "Search employee surname...",
    NO_ACCESS_TEXT: "User does not have permission to access.",

    // Administration
    CLIENT_ADMIN_ACTION_TEXT: "Go to Client",
    CLIENT_ADMIN_DESCRIPTION:
      "Edit the details, services and SLA measures of a client, and review their self-service requests.",
    DATA_ADMIN_DESCRIPTION:
      "Here you can administer the GoodShape service, including all hierarchy, service, employee and data admin. Here you can perform loading of bulk data files, including employee, absence and notification data.",
    DATA_ADMIN: "Data Admin",
    DATA_ADMIN_ACTION_TEXT: "Visit Data Admin",
    HIERARCHY_ADMIN: "Hierarchy Admin",
    HIERARCHY_ADMIN_DESCRIPTION:
      "Here you can perform loading of bulk data files, including employee, absence and notification data.",
    HIERARCHY_ADMIN_ACTION_TEXT: "View Hierarchy",
    EMPLOYEE_ADMIN: "Employee Admin",
    EMPLOYEE_ADMIN_DESCRIPTION:
      "Search for, access and edit the details of a specific employee record, including their personal details, employment details and notification set-up.",
    EMPLOYEE_ADMIN_ACTION_TEXT: "Search for an Employee",
    SERVICE_ADMIN: "Service Admin",
    SERVICE_ADMIN_DESCRIPTION:
      "Perform service administration, including the configuration of alerts, reports, absence recording rules, notifications, return to work interviews and much more.",
    SERVICE_ADMIN_ACTION_TEXT: "View Service Summary",
    // Menu
    CLIENT: "Client",
    DATA: "Data",
    SERVICE: "Service",
    EMPLOYEE: "Employee",
    EMPLOYEES: "Employees",
    HIERARCHY: "Hierarchy",
    SEE_ALL_CLIENTS: "See All Clients",
    THIRD_PARTY: "Third Party",
    HISTORIC: "Historic",
    SMS_OUTBOUND: "Out",
    SMS_INBOUND: "In",
    NEWS_CHANNEL: "News Channel",
    NEWS: "News",
    PROFILE: "Profile",
    NEWS_MODAL_TITLE: "The Shape of Things to Come!",
    AI_FEATURES_SURVEY: "AI Features Survey",
    DIRECT_REPORTS_ONLY: "Direct Reports Only",
    LAST_SIXTY_DAYS_PERFORMANCE: "Performance in Last 60 Days",
    PERFORMANCE_RATING: "Performance Rating",
    PERCENT_COMPLIANCE_SCORE: "% Compliance Score",
    TASKS_COMPLETED_ON_TIME: "Completed On-time",
    TASKS_COMPLETED: "Tasks Completed",
    TASKS_RATING_A:
      "You’ve been doing an excellent job recently and have been very compliant with your organisations policies.",
    TASKS_RATING_A_TITLE: "Rating: A - Excellent",
    TASKS_RATING_B:
      "You’ve been doing a very good job recently, with occasional lapses and missed deadlines. Keep it up!",
    TASKS_RATING_B_TITLE: "Rating: B - Very Good",
    TASKS_RATING_C:
      "Your have a mixed track record lately, with several tasks completed on time, but a lot also completed late.",
    TASKS_RATING_C_TITLE: "Rating: C - Average",
    TASKS_RATING_D:
      "Most of your tasks are completed late. This is limiting your ability to support employees and impact absence.",
    TASKS_RATING_D_TITLE: "Rating: D - Poor",
    TASKS_RATING_E:
      "Your recent performance is severely under-mining the ability to impact absence levels within your area.",
    TASKS_RATING_E_TITLE: "Rating: E - Very Poor",
    TASKS_RATING_NONE: "No Tasks has been completed in the last 60 days.",
    TASKS_OFFLINE_EXPORT: "Offline Export",
    TASKS_OFFLINE_EXPORT_TEXT:
      "Due to the size of the Task Queue, your Export will be queued for processing. An email will be sent to you one the export is available. You will need to click on the link in the email to download the export.",
    TASKS_OFFLINE_EXPORT_TEXT_2: "Do you wish to continue with the export?",
    CONFIRM_EXPORT: "Yes, Process export",
    // Form errors
    REQUIRED_FIELD: "This field is required",
    INCORRECT_PATTERN: "Incorrect field value provided",
    PERCENT_ABSENCES_OVERDUE_TOOLTIP:
      "At any given time, there should be <strong>no more than 10% of absences that are overdue</strong>. The higher the %, the less reliable reports will be. It will also negatively impact tasks and manager compliance rates.",
    PERCENT_CONSENT_WITHHELD_TOOLTIP:
      "The % of open absences that are consent withheld <strong>should not exceed 5%</strong>. If it does, it means that a client is missing a lot of vital information and their efforts to proactively manage and reduce absence will be constrained. If it is a very high % it may also suggest a lack of trust by employees.",
    PERCENT_WORK_RELATED_TOOLTIP:
      "The % of open absences that are classified as work related should generally <strong>not exceed 5%</strong>. While it is possible to have such a high number of legitimate work related absences, it is very unlikely and may suggest that employees are inappropriately claiming absences are work related when they are not.",
    PERCENT_TASKS_OVERDUE_TOOLTIP:
      "At any given time, there should be <strong>no more than 15% of tasks that are overdue</strong>. The higher the %, the less engaged managers are in the absence management process, or the GoodShape service. Managers play the biggest role in reducing absence, so their lack of engagement can be a serious problem that undermines the both GoodShape, and their organisations objectives.",
    PERCENT_APP_ADOPTION_TOOLTIP:
      "Clients are expected to have <strong>at least 67% of the users onboarded to the app</strong>. If they have less than this, it means they will continue to use the Call Centre heavily and are not in-line with GoodShape's strategic objective to become a digital, SaaS platform.",
  },
  options: {
    suppress_warnings: true,
  },
};

export const systemMessages = {
  en: {
    ...clientMessages.en,
    ...employeeMessages.en,
    ...hierarchyMessages.en,
    ...profileMessages.en,
    ...reportingMessages.en,
    ...serviceMessages.en,
    ...integrationsMessages.en,
    ...shared.en,
    // COMMON
    SUCCESSFULLY_ADDED: "Successfully added",
    SUCCESSFULLY_DELETED: "Successfully deleted",
    CALLBACK_ADDED: "Callback was successfully added",
    CALLBACK_UPDATED: "Callback was successfully updated",
    CALLBACK_REMOVED: "Callback was successfully removed",
    NO_RESULTS_TEXT: "No results for the specified criteria",
  },
};
